<template>
  <div id="app" class="col-md-8 col-xs-12 col-sm-12 col-12">
    <div class="row">
      <div
        class="col-12 d-flex justify-content-center justify-content-md-start"
      >
        <img
          :src="
            errorMode !== 0
              ? require(`../assets/error/error-toc-autocaptura.svg`)
              : require(`../assets/error/error-toc-autocaptura.svg`)
          "
          alt=""
          srcset=""
        />
      </div>
      <div class="col-xs-12 col-12">
        <h1 class="big-title text-left-desktop">
          {{ $t('m138') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-5">
        <p class="description-page md-text-center">
          {{ $t('m139') }}
        </p>
        <p
          v-if="errorMode === 0"
          class="description-page md-text-center font-weight-bold"
        >
          {{ $t('m140') }}
        </p>
        <p
          v-if="errorMode === 1"
          class="description-page md-text-center font-weight-bold"
        >
          {{ $t('m141') }}
        </p>
        <p
          v-if="errorMode === 2"
          class="description-page md-text-center"
          v-html="$t('m142')"
        ></p>
        <p
          v-if="errorMode === 3"
          class="description-page md-text-center"
          v-html="$t('m143')"
        ></p>
        <p v-if="errorMode === 0 || errorMode === 1" class="md-text-center">
          {{ $t('m144') }}
          <a role="button" tabindex="0" @click="modal = true">
            {{ $t('m145') }}
          </a>
        </p>
      </div>
      <template v-if="errorMode === 0 || errorMode === 1">
        <div class="col-md-7 col-xs-12 col-sm-12 col-12 my-3">
          <a-btn primary @click="goBack" :loading="loadingBtn">
            {{ $t('m146') }}
          </a-btn>
        </div>
        <div class="col-md-7 col-xs-12 col-sm-12 col-12 my-3">
          <a-btn
            secondary
            color="primary"
            class="font-weight-bold"
            @click="goToManual"
            :loading="loadingBtn"
          >
            {{ $t('m147') }}
          </a-btn>
        </div>
      </template>
      <template v-else>
        <div class="col-md-7 col-xs-12 col-sm-12 col-12 my-3">
          <a-btn
            secondary
            color="primary"
            class="font-weight-bold"
            @click="goToManual"
            :loading="loadingBtn"
          >
            {{ $t('m148') }}
          </a-btn>
        </div>
      </template>
    </div>
    <template v-if="errorMode === 0">
      <a-modal-toc-auto-captura :modal="modal" @close="modal = false" />
    </template>
    <template v-else-if="errorMode === 1">
      <a-modal-toc-liveness :modal="modal" @close="modal = false" />
    </template>
  </div>
</template>

<script>
import ABtn from '@/components/ui/ABtn';
import AModalTocAutoCaptura from '@/components/modals/AModalTocAutoCaptura';
import AModalTocLiveness from '@/components/modals/AModalTocLiveness';

export default {
  components: {
    ABtn,
    AModalTocAutoCaptura,
    AModalTocLiveness,
  },
  data() {
    return {
      modal: false,
      /* 0 = autocaptura
         1 = liveness
         2 = crítico conocido
         3 = crítico desconocido
      */
      errorMode: null,
      loadingBtn: false,
    };
  },
  methods: {
    goBack() {
      if (this.errorMode === 0) {
        this.$router.push({ name: 'TOC_ID' });
      } else {
        this.$router.push({ name: 'TOC_SELFIE' });
      }
    },
    goToManual() {
      if (this.errorMode === 0 || this.errorMode === 1) {
        this.loadingBtn = true;
        this.$store.dispatch('register/goToManual').then(resp => {
          this.loadingBtn = false;
          if (resp.registrationStep) {
            this.$router.push({ name: resp.registrationStep });
          }
        });
      } else {
        this.$router.push({ name: 'MANUAL_DOCUMENT' });
      }
    },
  },
  beforeMount() {
    switch (this.$route.path) {
      case '/admin/sign-up/error-toc-autocaptura':
        this.errorMode = 0;
        break;
      case '/admin/sign-up/error-toc-liveness':
        this.errorMode = 1;
        break;
      case '/admin/sign-up/critical-toc-error':
        this.errorMode = 2;
        break;
      case '/admin/sign-up/critical-unknown-toc-error':
        this.errorMode = 3;
        break;
    }
  },
};
</script>

<style></style>
